import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  MenuItemProfilAvatar: {
    width: 64,
    height: 64,
    borderRadius: 64,
    overflow: 'hidden',
    zIndex: 99,
    position: 'relative',
  },
});
